import { apiFetch } from './api-client'
import { useAuthStore } from './auth-store'

/**
 * Wraps apiFetch with the current user's artistId, so callers can use
 * relative module paths like `/pipeline` instead of `/artists/{id}/pipeline`.
 *
 * Throws if there's no authenticated session — should only be called from
 * inside protected routes.
 */
export function artistFetch<T>(
  modulePath: string,
  options?: Parameters<typeof apiFetch>[1],
): Promise<T> {
  const artistId = useAuthStore.getState().user?.artistId
  if (!artistId) {
    throw new Error('artistFetch called without an authenticated session')
  }
  const path = modulePath.startsWith('/') ? modulePath : `/${modulePath}`
  return apiFetch<T>(`/artists/${artistId}${path}`, options)
}
